import { render, staticRenderFns } from "./ArchiveThumb.vue?vue&type=template&id=522e68ef&scoped=true&"
import script from "./ArchiveThumb.vue?vue&type=script&lang=js&"
export * from "./ArchiveThumb.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveThumb.vue?vue&type=style&index=0&id=522e68ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522e68ef",
  null
  
)

export default component.exports